import _objectSpread from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { mapState, mapMutations } from "vuex";
import help from "./assets/js/help";
export default {
  name: "App",
  data: function data() {
    return {
      info: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(["uid", "token", "time", "isTest", "totalIngral"])), {}, {
    url: function url() {
      if (this.isTest) {
        return "/club/json/integral.json";
      } else {
        return "/api/goods/get-my-integral2";
      }
    },
    isDevelopment: function isDevelopment() {
      return process.env.NODE_ENV === "development";
    },
    param: function param() {
      var foo = "?";

      if (this.uid) {
        foo += "uid=" + this.uid + "&";
      }

      if (this.token) {
        foo += "token=" + this.token + "&";
      }

      if (this.time) {
        foo += "time=" + this.time;
      }

      return foo;
    }
  }),
  created: function created() {
    window.registerUserInfo = this.getAppInfo;
  },
  methods: _objectSpread(_objectSpread({}, mapMutations(["setUid", "setTotalIngral", "setAppInfo"])), {}, {
    getTotalIngral: function getTotalIngral() {
      var _this = this;

      this.axios.get(this.url + this.param).then(function (res) {
        if (res) {
          help.requestEmptySuccess(res).then(function (res) {
            _this.setTotalIngral(res.data);
          }, function (err) {
            help.resError(err, true, _this.logout, _this.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    getAppInfo: function getAppInfo(param) {
      console.log(param);
      this.setAppInfo(JSON.parse(param));
    }
  }),
  mounted: function mounted() {
    if (this.isDevelopment) {
      if (!this.uid) {
        this.setAppInfo({
          uid: "9381",
          token: "6d73502a6625152d58d10c6b5bdba685",
          time: "1688439490",
          phone: "12100000001"
        });
      }
    } else {
      window.getUserInfo();
    }
  }
};